import api from '@services/api';
import { AllocationConstraintResponse, CreateAllocationConstraintRequest } from '../models/allocationConstraint';
import { ExtraCollaboratorByPersonResponse } from '../models/extraCollaborator';

interface RequestAllocationConstraint {
  badge: string;
}

/**
 * <p>
 * API endpoints that cover all sharing related CRUD calls
 */

export const allocationConstraintApi = api.injectEndpoints({
  endpoints: (builder) => ({
    ListAllAllocationConstraintByPerson: builder.query<ExtraCollaboratorByPersonResponse[], string>({
      query: (badge: string) => {
        return {
          url: encodeURI(`/indirect/rule-allocation-restriction/findAllByPerson?badge=${badge}`),
          method: 'GET',
        };
      },
      providesTags: ['ListAllGroupedAllocationConstraint'],
    }),
    ListAllGroupedAllocationConstraint: builder.query<AllocationConstraintResponse[], string>({
      query: (parans: string) => {
        const searchTerm = parans ?? '';
        return {
          url: encodeURI(`/indirect/rule-allocation-restriction/findAllGrouped?searchTerm=${searchTerm}`),
          method: 'GET',
        };
      },
      providesTags: ['ListAllGroupedAllocationConstraint'],
    }),
    createAllocationConstraint: builder.mutation<void, CreateAllocationConstraintRequest>({
      query: (input) => ({
        url: '/indirect/rule-allocation-restriction/create',
        method: 'POST',
        body: input,
      }),
      invalidatesTags: ['ListAllGroupedAllocationConstraint'],
    }),
    removeAllocationConstraint: builder.mutation<void, string>({
      query: (id) => ({
        url: `/indirect/rule-allocation-restriction/delete?badge=${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ListAllGroupedAllocationConstraint'],
    }),
  }),
});

export const {
  useListAllAllocationConstraintByPersonQuery,
  useListAllGroupedAllocationConstraintQuery,
  useCreateAllocationConstraintMutation,
  useRemoveAllocationConstraintMutation,
} = allocationConstraintApi;
